import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { Header } from '@/components/Generic'
import { Illustration } from '@/components/Illustration/Illustration'

export const PendingSignatoriesPage = observer(() => {
  const store = useContext(StoreContext)
  const { pendingSignatoriesPage: trans } = store.TranslationsState.translations

  return (
    <div className="page-container p-50 mobile-m-10">
      <Illustration type="pending-signatories" />

      <Header className="m-0-0-30">{trans?.title}</Header>

      <p className="generic__paragraph-centered m-0-0-30">
        {trans?.description}
        <br />
        {trans?.pleaseTryAgain}
      </p>
    </div>
  )
})
